module.exports = "../../../../platform/assets/pageMainIcon/youth_yewushezhilei1.svg";